import p1 from "../Assets/img/prod/qblbasP1.jpg";
import p2 from "../Assets/img/prod/qblbasP2.jpg";
import p3 from "../Assets/img/prod/qblbasP3.jpg";
import p4 from "../Assets/img/prod/qblbasP4.jpg";
import p5 from "../Assets/img/prod/qblbasP5.jpg";
import p6 from "../Assets/img/prod/qblbasP6.jpg";
import p7 from "../Assets/img/prod/qblbasP7.jpg";
import p8 from "../Assets/img/prod/qblbasP8.jpg";
import p9 from "../Assets/img/prod/qblbasP9.jpg";
import p10 from "../Assets/img/prod/qblbasP10.jpg";
import p11 from "../Assets/img/prod/qblbasP11.jpg";
import p12 from "../Assets/img/prod/qblbasP12.jpg";
import p13 from "../Assets/img/prod/qblbasP13.jpg";
import p14 from "../Assets/img/prod/qblbasP14.jpg";
import p15 from "../Assets/img/prod/qblbasP15.jpg";
import p16 from "../Assets/img/prod/qblbasP16.jpg";
import p17 from "../Assets/img/prod/qblbasP17.jpg";
import p18 from "../Assets/img/prod/qblbasP18.png";
import p19 from "../Assets/img/prod/qblbasP19.png";
import p20 from "../Assets/img/prod/qblbasP20.png";
import p22 from "../Assets/img/prod/qblbasP22.png";
import p23 from "../Assets/img/prod/qblbasP23.jpg";
import p24 from "../Assets/img/prod/qblbasP24.jpg";
import p25 from "../Assets/img/prod/qblbasP25.jpg";

export const products = {
  en: [
    {
      id: 1,
      name: "Equal Angle Steel",
      img: p1,
      description: "(20x20x2mm to 150x150x15mm)",
    },
    {
      id: 2,
      name: "Unequal Angle Steel",
      img: p2,
      description: "(40x25x4mm to 200x150x15mm)",
    },
    {
      id: 3,
      name: "Round Bar",
      img: p3,
      description: "(4mm to 30mm diameter)",
    },
    {
      id: 4,
      name: "Deformed Bar",
      img: p4,
      description: "(8mm to 32mm)",
    },
    {
      id: 5,
      name: "Hollow Section",
      img: p5,
      description: "(Rectangular 10x20x0.50mm to 150x200x8.00mm) (Square 15x15x0.50mm to 175x175x3.00mm) (Round 10x0.50mm to 219x8.00mm)",
    },
    {
      id: 6,
      name: "Channel Steel",
      description: "(UPN 50 to 400) & (UPE 80 to 400mm)",
      img: p6,
    },
    {
      id: 7,
      name: "H Beam",
      description: "(HE 100 to 1000)",
      img: p7,
    },
    {
      id: 8,
      name: "Cold Rolled Coils/Sheet",
      description: "(Thickness. 0.20mm to 3.00mm) (Width max. 1800mm) (Quality. DC01, DC03, DC04, DC05) ",
      img: p8,
    },
    {
      id: 9,
      name: "Hot Rolled Coils/Sheet",
      description: "(Thickness. 1.20mm to 6.00mm) (Width max. 2000mm) (Quality. Grade A / Grade B / S235JR - J0, J2, J2H, +N, +M / S275JR, J0, J2, J2H, +N, +M / J0, J2, J2H, +N, +M / P235TR1, HG)",
      img: p9,
    },
    {
      id: 10,
      name: "Pre Painted Corrugated Roofing Sheet",
      description: "thickness:(0.16 to 0.80mm) (width: 1.200,1.220,1250mm) (length: from 1.50m to 15m)",
      img: p10,
    },
    {
      id: 11,
      name: "IPE",
      description: "(IPE 80 to 750)",
      img: p11,
    },
    {
      id: 12,
      name: "Corraguated Steel Sheet",
      description: "(thickness:0.30 to 0.80mm) (width: 1.200,1.220,1250mm) (length: from 1.50m to 15m)",
      img: p12,
    },
    {
      id: 13,
      name: "Hot Dipped Gi Coils/Sheet",
      description: "(Thickness. 0.20mm to 6.00mm) (Width max. 1500mm) (Quality. DX51D+Z / DX52D+Z / DX53D+Z / DX54D+Z / DX56D+Z) (Coating Z20 to Z550g/m²)f",
      img: p13,
    },
    {
      id: 14,
      name: "PPGI Coils/Strip",
      description: "(Thickness. 0.15mm to 1.20mm) (Width max. 1,250mm) (Quality. JIS G3302, JIS G3313, ASTM A653, GB/T2518-88, GB11253-89, BS, Etc...) (Coating 15 to 120g/m²)",
      img: p14,
    },
    {
      id: 15,
      name: "Wired Rod",
      description: "(Diameter 5.5mm to 10mm)",
      img: p15,
    },
    {
      id: 17,
      name: "Wired Rod",
      description: "(Diameter 5.5mm to 10mm)",
      img: p17,
    },
    {
      id: 16,
      name: "Flat Bar",
      description: "(Width 20mm to 150mm) ",
      img: p16,
    },
    {
      id: 18,
      name: "Polyol",
      description: "Polyol",
      img: p18,
    },
    {
      id: 20,
      name: "MDI ",
      description: "MDI",
      img: p20,
    },
    {
      id: 22,
      name: "Catalyst ",
      description: "Catalyst",
      img: p22,
    },
    {
      id: 19,
      name: "BRC ",
      description: "(100mm*100mm to 200mm*200mm) (thickness:4.8mm to 8.0mm) (length: 6000mm) (width max. 2000mm)",
      img: p19,
    },
    {
      id: 23,
      name: "Convan ",
      description: "Depending on the request",
      img: p23,
    },
    {
      id: 24,
      name: "Cargo Container Home",
      description: "Depending on the request",
      img: p24,
    },
    {
      id: 25,
      name: "Structural Steel Construction",
      description: "Depending on the request",
      img: p25,
    },
    
  ],
  kur: [
    {
      id: 1,
      name: "گۆشەبەند",
      img: p1,
    },
    {
      id: 2,
      name: "گۆشەبەندی لا جیاواز",
      img: p2,
    },
    {
      id: 3,
      name: "شیشی پیشەسازی",
      img: p3,
    },
    {
      id: 4,
      name: "شیش",
      img: p4,
    },
    {
      id: 5,
      name: "پڕۆفیل",
      img: p5,
    },
    {
      id: 6,
      name: "چەنەڵ",
      img: p6,
    },
    {
      id: 7,
      name: "H شیلمان",
      img: p7,
    },
    {
      id: 8,
      name: "ۆڵ و پلێتی سارد",
      img: p8,
    },
    {
      id: 9,
      name: "ڕۆڵ و پلێتی گەرم",
      img: p9,
    },
    {
      id: 10,
      name: "کێربی ڕەنگی",
      img: p10,
    },
    {
      id: 11,
      name: "شێلمان",
      img: p11,
    },
    {
      id: 12,
      name: "کێربی و جەمەلۆن",
      img: p12,
    },
    {
      id: 13,
      name: "ڕۆڵی گەلڤەنایز",
      img: p13,
    },
    {
      id: 14,
      name: "ڕۆڵی ڕەنگی",
      img: p14,
    },
    {
      id: 15,
      name: "تێلی BRC",
      img: p15,
    },
    {
      id: 16,
      name: "ڕاستە",
      img: p16,
    },
  ],
  ar: [
    {
      id: 1,
      name: "زوايا مربعة",
      img: p1,
    },
    {
      id: 2,
      name: "زوايا غير مربعة",
      img: p2,
    },
    {
      id: 3,
      name: "شيش املس",
      img: p3,
    },
    {
      id: 4,
      name: "حديد تسليح",
      img: p4,
    },
    {
      id: 5,
      name: "مقاطع مربعة و مستطيلة",
      img: p5,
    },
    {
      id: 6,
      name: "جنل",
      img: p6,
    },
    {
      id: 7,
      name: "جسور(شيلمان) H",
      img: p7,
    },
    {
      id: 8,
      name: "رول و شيت بارد",
      img: p8,
    },
    {
      id: 9,
      name: "رول و شيت حار",
      img: p9,
    },
    {
      id: 10,
      name: "صفائح سقف ملونة",
      img: p10,
    },
    {
      id: 11,
      name: "شیلمان",
      img: p11,
    },
    {
      id: 12,
      name: "صفائح سقف",
      img: p12,
    },
    {
      id: 13,
      name: "رول مغلون",
      img: p13,
    },
    {
      id: 14,
      name: "رول ملون",
      img: p14,
    },
    {
      id: 15,
      name: "سلك حديد",
      img: p15,
    },
    {
      id: 16,
      name: "قضبان مسطحة",
      img: p16,
    },
  ],
};
